<div class="container" dir="rtl">
  <div *ngIf="report?.FailureRiskScore" class="container">
    <ng-container *ngIf="report?.FailureRiskScore !== -1">
      <div class="report-card">
        <p class="report-text text-center">{{report?.ProblemCategory}}</p>
        <div class="score-section py-4">
          <div class="score-number">
            <small>100 /</small>
            {{ report?.FailureRiskScore }}
          </div>

          <div class="progress-track">
            <div class="progress-fill" [style.width.%]="report?.FailureRiskScore"></div>
          </div>

          <div class="text-center pt-4">
            <span
              class="status-badge"
              [ngClass]="{
                'good': report?.FailureRiskScore >= 70,
                'medium': report?.FailureRiskScore >= 40 && report?.FailureRiskScore < 70,
                'bad': report?.FailureRiskScore < 40
                }">
              {{ report?.RiskLevel }}
            </span>
          </div>
        </div>

        <div class="report-section">
          <h3>گزارش تحلیل</h3>
          <div class="report-text">
            {{ report?.DiagnosticReport }}
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
